import { useParams } from 'react-router';
import { ScreenSkeleton } from '../../../components/atoms/ScreenSkeleton';
import { ShoeRollerPathScreen } from './shoes/ShoeRollerPathScreen';
import { DriveTumblerRollerPathScreen } from './driveTumbler/DriveTumblerRollerPath';

export const RollerPathFactoryScreen = () => {
  const { partCategory } = useParams();

  switch (partCategory) {
    case 'shoes':
      return <ShoeRollerPathScreen />;
    case 'drive-tumbler':
      return <DriveTumblerRollerPathScreen />;
    default:
      return <ScreenSkeleton fields={4} />;
  }
};
